import { useScrollReveal } from '@/hooks/useScrollReveal';

const ForNotFor = () => {
  const [ref, isVisible] = useScrollReveal();

  return (
    <section
      ref={ref}
      data-testid="for-not-for-section"
      className={`section-reveal ${isVisible ? 'visible' : ''}`}
      style={{ backgroundColor: '#3A3D42' }}
    >
      <div className="content-wide">
        <div className="grid md:grid-cols-2 gap-12 md:gap-16">
          <div data-testid="for-block">
            <p className="for-heading">
              <span className="coral-dot-icon"></span>
              This is for you if:
            </p>
            <p className="body-text mt-5">
              You&rsquo;re generating revenue but can&rsquo;t tell which activities are actually driving it. You have a cofounder situation that&rsquo;s draining energy you should be spending on growth. You&rsquo;ve raised or are raising funding and your story doesn&rsquo;t hold up under pressure.
            </p>
          </div>

          <div data-testid="not-for-block">
            <p className="not-for-heading">
              <span className="charcoal-dot-icon"></span>
              This is not for you if:
            </p>
            <p className="body-text-secondary mt-5">
              You need someone to tell you to wake up early and write a gratitude journal. You want a strategy deck you can show your board and never execute. You&rsquo;re looking for an agency to run your marketing while you focus on product &mdash; I don&rsquo;t execute your to-do list.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ForNotFor;
